import {ComponentType} from 'react';

import loadable from '../../../../../utils/loadable';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

const AssetDpdContextProvider: ComponentType<unknown> = loadable({
	loader: () => import('../../../../../modules/dataprocessingdefinitions/AssetDataProcessingDefinitionPage')
});
export default {
	relativePath: 'edit/:dataProcessingDefinitionId',
	label: {
		id: 'assets.detail.dataProcessingDefinition.edit.title',
		defaultValue: 'Edit Data Processing Definition'
	},
	component: AssetDpdContextProvider
} satisfies RouteConfig;
